import App from "./App";
import ReactDOM from "react-dom";
import { StrictMode } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById("root")
);
